"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("./client");
Object.defineProperty(exports, "createAnalytics", { enumerable: true, get: function () { return client_1.default; } });
var analytics_1 = require("analytics");
Object.defineProperty(exports, "Analytics", { enumerable: true, get: function () { return analytics_1.default; } });
//# sourceMappingURL=index.js.map